<div class="info" *ngIf="isShowing" [@infoAnimation]>
  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse ultrices sem nec nulla porta faucibus. Aenean
  sed ex at velit volutpat accumsan. Sed et tortor elementum, tristique dui non, tincidunt est. Duis condimentum id
  velit sit amet aliquet. Integer nec efficitur dolor. Morbi sed purus sit amet metus sodales tristique id eget
  urna. Donec sed mi tellus. Pellentesque fermentum sem a ultrices efficitur. Vestibulum volutpat est a dui auctor,
  at volutpat massa ultrices. Sed id maximus metus. Integer tempor velit at neque ultricies, vel varius risus
  elementum. Quisque tempor dignissim magna pellentesque iaculis. Mauris tempus ligula neque. Ut at lacus.
</div>

<form *ngIf="isShowing && thirdStepSignup" [@formAnimation] [formGroup]="thirdStepSignup" (ngSubmit)="onSubmit(thirdStepSignup)"
  ngNativeValidate class="form" #secondStepForm="ngForm">
  <h3 class="form--title">Fale um pouquinho de sua empresa e seu papel</h3>

  <mat-form-field appearance="outline">
    <mat-label>Website</mat-label>
    <input matInput type="url" id="website" name="website" formControlName="website" required>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Área de Atuação</mat-label>
    <input matInput type="text" id="industry" name="industry" formControlName="industry" required>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Seu papel</mat-label>
    <input matInput type="text" id="role" name="role" formControlName="role" required>
  </mat-form-field>

  <div class="button-container">
    <button mat-raised-button class="button button__next" type="submit"
      [disabled]="thirdStepSignup.invalid">Próximo</button>
  </div>
</form>